import { CollectionCard } from '@/components/content-types/collection-type/components/collectionCard';

export const RelatedPosts = ({ posts, maxLimit = 4 }) => {
    if (!posts || !Array.isArray(posts) || posts.length === 0) {
        return null;
    }

    const limitedPosts = posts.slice(0, maxLimit);

    const getGridClasses = (count) => {
        if (count === 1) return 'grid grid-cols-1 gap-6';
        if (count === 2) return 'grid grid-cols-1 gap-6 sm:grid-cols-2';
        if (count === 3) return 'grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3';
        return 'grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4';
    };

    return (
        <div className="p-4 pt-11 md:p-16 lg:px-32">
            <div className="container p-0">
                <div className="mb-12 flex flex-col gap-8 lg:mb-24">
                    <div className="text-2xl font-bold leading-tight dark:text-white">
                        Recommended Reading
                    </div>
                    <ul className={getGridClasses(limitedPosts.length)}>
                        {limitedPosts.map((contentlet, i) => (
                            <li
                                className="card-hover-pop relative cursor-pointer rounded-lg shadow-md"
                                key={contentlet.identifier || i}>
                                <CollectionCard
                                    contentlet={contentlet}
                                    contenttype="Blog"
                                    showCategory={true}
                                    showAuthor={true}
                                    headerType="h3"
                                />
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};
